module.exports = __webpack_public_path__ + "img/live2.cf45d6da.png";